<app-dashboard-layout-header (toggleSidebar)="onSidebarToggle()"></app-dashboard-layout-header>

<p-drawer
  [(visible)]="sidebarVisible"
  [modal]="false"
  [closable]="false"
  [autoZIndex]="false"
  [baseZIndex]="999"
  styleClass="sidebar"
>
  <ng-template pTemplate="headless">
    <app-dashboard-layout-sidebar></app-dashboard-layout-sidebar>
  </ng-template>
</p-drawer>

<ng-content></ng-content>
